import Component from 'gia/Component';

import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export default class IntroImages extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      images: []
    }
  }

  mount() {

    // let timeline = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: 'body',
    //     scrub:1,
    //     start: "top top"
    //   }
    // });
    //
    // this.ref.images.forEach((image, index) => {
    //   timeline.to(image, {
    //     'opacity': '100%',
    //     duration:0.1
    //   });
    // });

    this.ref.images.forEach((image, index) => {
      gsap.to(image, {
        'opacity': '100%',
        duration:0.0001,
        scrollTrigger: {
          trigger: index == 0 ? 'body' : image,
          start: index == 0 ? '10' : "top center"
        }
      });
    });

  }


}